import { render, staticRenderFns } from "./OrthoWorse.vue?vue&type=template&id=1ba37ebc&scoped=true"
import script from "./OrthoWorse.vue?vue&type=script&lang=js"
export * from "./OrthoWorse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba37ebc",
  null
  
)

export default component.exports